import { render } from "./app-form-state.vue?vue&type=template&id=3d5d4f84"
import script from "./app-form-state.vue?vue&type=script&lang=js"
export * from "./app-form-state.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/components/form/reference/app-form-state.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3d5d4f84"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3d5d4f84', __exports__)) {
    console.log('reload')
    api.reload('3d5d4f84', __exports__)
  }
  
  module.hot.accept("./app-form-state.vue?vue&type=template&id=3d5d4f84", () => {
    console.log('re-render')
    api.rerender('3d5d4f84', render)
  })

}


export default __exports__